export const HYDRATE_FROM_URL = 'HYDRATE_FROM_URL';
export const SET_QUERY = 'SET_QUERY';
export const SET_FACET = 'SET_FACET';
export const SET_ALL_FACETS = 'SET_ALL_FACETS';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const SEARCH_PENDING = 'SEARCH_PENDING';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILED = 'SEARCH_FAILED';
export const SET_SEARCH_RUNTIME_CONFIG = 'SET_SEARCH_RUNTIME_CONFIG';
export const SET_PAGE = 'SET_PAGE';
